import { useEffect, useState } from 'react';

import { availablePeriodsApi, useAvailablePeriods } from '@entities/available-periods';

import { xhr } from '@shared/config';
import type { AvailablePeriod } from '@shared/types/available-periods';

export const useAvailablePeriodLoader = (id: number) => {
	const { addAvailablePeriod } = useAvailablePeriods();

	const [isLoading, setIsLoading] = useState(false);

	const loader = () => {
		const controller = new AbortController();
		const loadAvailablePeriod = async () => {
			if (!id || isNaN(id)) return;

			setIsLoading(true);
			try {
				const res = await xhr.get<AvailablePeriod>(`${availablePeriodsApi}${id}/`, {
					signal: controller.signal,
				});

				if (!res.data) throw res;

				addAvailablePeriod(res.data);
			} catch (error) {}
			setIsLoading(false);
		};

		loadAvailablePeriod();

		return () => {
			controller.abort();
		};
	};

	useEffect(loader, [id]);
	return {
		isLoading,
	};
};
